package com.essntl.features.crm.ui.contactorganization

import com.essntl.features.address.domain.model.AddressModel
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.customfields.domain.model.CustomFieldsModel
import com.essntl.features.organization.domain.model.OrganizationModel

interface ContactOrganizationEvent {
    data class Submit(
        val organization: OrganizationModel,
        val organizationAddress: AddressModel?,
        val contact: ContactModel,
        val contactAddress: AddressModel?,
        val customFields: CustomFieldsModel,
    ) : ContactOrganizationEvent

    data object ClearState : ContactOrganizationEvent
}